(function () {
  function initCollapsibleSiblings() {
    const containers = document.querySelectorAll('[data-collapsible-siblings]');

    containers.forEach((container) => {
      const toggle = container.querySelector('[data-siblings-toggle]');
      if (!toggle) return;

      const showLabel = toggle.querySelector('[data-toggle-show]');
      const hideLabel = toggle.querySelector('[data-toggle-hide]');

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          container.classList.add('is-collapsed');
          toggle.setAttribute('aria-expanded', 'false');
          if (showLabel) showLabel.hidden = false;
          if (hideLabel) hideLabel.hidden = true;
        } else {
          container.classList.remove('is-collapsed');
          toggle.setAttribute('aria-expanded', 'true');
          if (showLabel) showLabel.hidden = true;
          if (hideLabel) hideLabel.hidden = false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapsibleSiblings);
  } else {
    initCollapsibleSiblings();
  }
})();